export default __webpack_public_path__ + "static/media/dog_love_24x.068221ba.svg";